import SocialMediaIcons from "../components/SocialMediaIcons";

const Footer = () => {
  return (
    <footer className="bg-red pt-10 pb-10">
      <div className="w-11/12 md:w-10/12 mx-auto">
        <SocialMediaIcons />
        <div className="flex flex-col items-center justify-center gap-4 text-center md:flex-row md:justify-between">
          <p className="font-playfair font-semibold text-2xl text-yellow">
            Rylan Burkket
          </p>
          <p className="font-playfair text-md text-yellow">
            ©2023 Island Meadow. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
